module.exports = window.jQuery;


//////////////////
// WEBPACK FOOTER
// external "window.jQuery"
// module id = 0iPh
// module chunks = wizard customizer customizer-fonts crm crm-datatables blog app admin